<div class="modal">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h3>{{data.terms.title || 'Terms and Conditions'}}</h3>
  </section>
  <section mat-dialog-content>
    @if (data.terms) {
      <div [innerHTML]="data.terms.body"></div>
    }
  </section>
</div>